import { getTenantCustomizations } from './registry';

export interface TenantPublicPortalExpectation {
  unified: boolean;
}

/** Public auth topology from eager metadata only; no shell or page is loaded. */
export const tenantPublicPortalExpectations: Record<string, TenantPublicPortalExpectation> =
  Object.fromEntries(
    getTenantCustomizations().map(customization => [
      customization.code,
      { unified: customization.capabilities?.unifiedPortal === true },
    ])
  );
